import React from "react";
import "./PaintSkeleton.css";

// The Profile drawer's first-ever open in a session (nothing remembered yet —
// lib/pageCache): the drawer's own boxes — photo + name, the Request Price
// card, the menu rows — softly lit where the content lands, instead of a
// "Loading…" line (1.5.2). Built from the real classes so the sizes match.
export default function ProfileDrawerSkeleton() {
  return (
    <div className="pds" aria-busy="true">
      <div className="profile-head-row">
        <div className="profile-avatar-wrapper">
          <span className="psk psk--round pds-avatar" />
        </div>
        <div className="pds-lines">
          <span className="psk pds-line pds-line--name" />
          <span className="psk pds-line pds-line--sub" />
        </div>
      </div>
      <div className="profile-price-card-wrap">
        <div className="profile-price-card pds-price">
          <div className="pds-lines">
            <span className="psk pds-line pds-line--label" />
            <span className="psk pds-line pds-line--amount" />
          </div>
        </div>
      </div>
      <div className="profile-divider" aria-hidden="true" />
      <div className="profile-menu">
        {[0, 1, 2, 3, 4].map((i) => (
          <div className="profile-menu-row pds-row" key={i}>
            <span className="psk pds-ic" />
            <span className="psk pds-line pds-line--row" />
          </div>
        ))}
      </div>
    </div>
  );
}
